import { ChecklistItem } from "."
import { useGetUpgradeModal } from "../../../../../hooks"

export const InviteTeam = ({ forConfirmed }) => {
    const { planId } = useGetUpgradeModal()
    const isTeamPlan = planId === 'team'
    return <ChecklistItem forConfirmed={forConfirmed}>{`Invite ${isTeamPlan ? '4+ additional' : 'unlimited'} users to join your Rarchy team, to collaborate and keep your work in one place`}</ChecklistItem>
}